import { useState, useEffect, useRef } from 'react';

export default function useComponentVisible(initialIsVisible?: boolean) {
    
    const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
    const ref: any = useRef(null);

    const handleClickOutside = (event: any) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setIsComponentVisible(false);
        }
    };



    useEffect(() => {
        /* console.log("outside filter menu ") */
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [isComponentVisible]);

    return { ref, isComponentVisible, setIsComponentVisible };
}